import React, {useState, useEffect} from "react";
import Header from '../include/header';
import Footer from '../include/footer';
import LeftPanel from '../include/leftpanel';
import Global from "../../APIConfig";
import  axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import MainLoader from "../Loaders/MainLoader";
import ListLoader from "../Loaders/ListLoader";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Select from 'react-select';
import { Button } from "react-bootstrap";
import { Typeahead } from 'react-bootstrap-typeahead';

function AllScheduledPickupList(){
    let navigate = useNavigate();
    let {sp_no} = useParams(); 
    let {cust_id} = useParams(); 
    const [list, setList] = useState([]);
    const [Loading, setLoading] = useState(true); 
    const [SubLoading, setSubLoading] = useState(false); 
    const{headers1,headers2,logout}=AuthUser();
    const [checkedItems, setCheckedItems] = useState([]);
    const [countrylist, setCountrylist] = useState([]);
    const [citylist, setCitylist] = useState([]);
    const [hublist, setHublist] = useState([]);
    const [routecodelist, setRoutecodelist] = useState([]);
    const [messengerlist, setMessengerlist] = useState([]);
    const [pickuplist, setPickuplist] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedRouteCode, setSelectedRouteCode] = useState('');
    const [selectedMessenger, setSelectedMessenger] = useState('');
    const [selectedHub, setSelectedHub] = useState('');
    const [defaulcountryname, setDefaulcountryname] = useState('');
    const [BtnLoading, setBtnLoading] = useState(false);
    const [Btn1Loading, setBtn1Loading] = useState(false);
    const [userdata, setUserdata] = useState('');
    const [customerlist, setCustomerlist] = useState([]);
    const [customerid, setCustomerid] = useState('');
    const [selectedcustomer, setSelectedcustomer] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(()=>{
        Getcustomerlist();
        GetCountrylist();
        const items = JSON.parse(localStorage.getItem('user'));
         setUserdata(items);
    },[]);

    const Getcustomerlist=()=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'Customerlist',
                headers:headers1,
                
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    setCustomerlist(response.data.value);
                }
                else
                {
                    setCustomerlist([]);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
        }

        const filterBy = (option, state)=> {
        if (state.selected.length) {
          return true;
        }
        return option.label.toLowerCase().indexOf(state.text.toLowerCase()) > -1;
      }

        const handelcustomerid=(e)=>{
        const id = e[0].value;
        const name = e[0].label;
        setSelectedcustomer(name)
        setCustomerid(id);
    }

    const handleChange = (event) => {
        const slip_no = event.target.value;
        if(!checkedItems.includes(slip_no)){
            setCheckedItems([...checkedItems,slip_no]);
        }else{
            let arr=checkedItems.filter((item)=>item!==slip_no);
            setCheckedItems(arr);
        }
        
      };

      const handleSelectAllChange = (event) => {
        if (event.target.checked) {
            const allSlipNos = list.map(item => item.slip_no);
            setCheckedItems(allSlipNos);
        } else {
            setCheckedItems([]);
        }
    };
   
    const isChecked = (slip_no) => checkedItems.includes(slip_no);

    const handleCountryChange = (event) => {
        const countryname = event.target.value;
        setSelectedCountry(event.target.value);
        GetCityList(countryname);
    };

    const GetCityList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Citylist',
            data: {
                name: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCitylist(data);
            }
            else
            {
                setCitylist([]);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }

    const GetCountrylist=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Countrylist',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCountrylist(data);
            }
            setLoading(false);
          })
          .catch(function (error) {
            // console.log(error);
            setLoading(false);
          });
    }

    // Handle city selection
    const handleCityChange = (event) => {
        const cityid = event.value;
        setSelectedCity(event.value);
        GetHubList(cityid);
        GetRouteCodeList(cityid);
        GetMessengerList(cityid);
    };

    // Handle Hub selection
    const handleHubChange = (event) => {
        setSelectedHub(event.value);
    };

    // Handle Hub selection
    const handleRouteCodeChange = (event) => {
        setSelectedRouteCode(event.value);
    };

    // Handle Hub selection
    const handleMessengerChange = (event) => {
        setSelectedMessenger(event.value);
    };

    const GetHubList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Hublist',
            data: {
                cityid: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setHublist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }

    const GetRouteCodeList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Routecodelist',
            data: {
                cityid: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setRoutecodelist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }

    const GetMessengerList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Messengerlist',
            data: {
                cityid: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setMessengerlist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }

    const Submitpickup=()=>
        {
             if(customerid =='')
             {
                 toast.warn('Please Select Customer!');
                 return;
             }
            //  else if(selectedCity =='')
            //  {
            //      toast.warn('Please Select City!');
            //  }
            //  else if(selectedHub == '')
            //  {
            //      toast.warn('Please Select Hub!');
            //  }
            //  else if(selectedRouteCode == '')
            //  {
            //      toast.warn('Please Select Route Code!');
            //  }
            //  else if(selectedMessenger == '')
            //  {
            //      toast.warn('Please Select Messenger!');
            //  }
            //  else if(checkedItems =='')
            //  {
            //      toast.warn('Please Select At Least One Shipment!');
            //  }
                 setBtnLoading(true);
                 setIsSubmitting(true);
                 axios({
                     method: 'post',
                     url: Global.baseUrl+'AllSchedulepickuplist',
                     headers:headers1,
                     data: {
                         custid: customerid,
                         usertype: userdata.usertype,
                         messengerid: selectedMessenger,
                         routecode: selectedRouteCode,
                         cityid: selectedCity,
                         hubid: selectedHub 
                     }
                   })
                   .then(function (response) {
                     if(response.data.status == 200)
                     {
                         var data=response.data.value;
                            setList(data);
                            setLoading(false);
                            setSubLoading(false);
                     }
                     else{
                         toast.success(response.data.error);
                     }
                     setBtnLoading(false);
                     setIsSubmitting(false);
                   })
                   .catch(function (error) {
                     setBtnLoading(false);
                     setIsSubmitting(false);
                     if(error.response.status==401){
                         toast.error(error.response.statusText);
                         logout();
                         navigate('/');
                         window.location.reload();
                     }
                     // console.log(error);
                   });
         }

return(
    <>
        <LeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer/>
            {Loading==true ? <MainLoader/> :
            <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Schedule Shipments</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">All Schedule Shipments</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card mb-3">
              <div className="card-body">
                <div className="row">
                    <div className="col-12 col-md-4 mb-3">
                        <div><label htmlFor="email" className="form-label">Select Customer: <span className="text-danger">*</span></label></div>
                        <Typeahead
                            filterBy={filterBy}
                            id="toggle-example1"
                            options={customerlist}
                            placeholder="Choose a customer..."
                            onChange={handelcustomerid}
                        />
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <div><label htmlFor="email" className="form-label">Select Country: <span className="text-danger">*</span></label></div>
                        <select className="form-select" onChange={handleCountryChange}>
                          <option value="">-- Please Select --</option>
                          {countrylist.map((list,i)=>{
                            return (
                            <option value={list.country} selected={defaulcountryname == list.country} key={i}>{list.country}</option>
                            );
                            })}
                        </select>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <div><label htmlFor="email" className="form-label">Select City: <span className="text-danger">*</span></label></div>
                        <Select
                        // defaultValue={selectedOption} 
                        onChange={handleCityChange}
                        options={citylist} 
                        placeholder="Enter city name"
                        />
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <div className="d-flex justify-content-between">
                            <div ><label htmlFor="email" className="form-label">Select HUB: <span className="text-danger">*</span></label> </div>
                            <div><small className=""><Link target="_blank" to={`/HubAdd`} tabIndex={-1} className="text-muted">Add New HUB</Link></small></div>
                        </div>
                        <Select
                        // defaultValue={selectedOption} 
                        onChange={handleHubChange}
                        options={hublist} 
                        placeholder="Select Hub"
                        />
                    </div>
                    {/* <div className="col-12 col-md-4 mb-3">
                        <div className="d-flex justify-content-between">
                            <div ><label htmlFor="email" className="form-label">Select City Route Code: <span className="text-danger">*</span></label> </div>
                            <div><small className=""><Link target="_blank" to={`/RouteAdd`} tabIndex={-1} className="text-muted">Add New Route Code</Link></small></div>
                        </div>
                        <Select
                        // defaultValue={selectedOption} 
                        onChange={handleRouteCodeChange}
                        options={routecodelist} 
                        placeholder="Select Route Code"
                        />
                    </div> */}
                    <div className="col-12 col-md-4 mb-3">
                        <div className="d-flex justify-content-between">
                            <div ><label htmlFor="email" className="form-label">Select Messenger (Driver): <span className="text-danger">*</span></label> </div>
                            <div><small className=""><Link target="_blank" to={`/DriverAdd`} tabIndex={-1} className="text-muted">Add New Driver</Link></small></div>
                        </div>
                        <Select
                        // defaultValue={selectedOption} 
                        onChange={handleMessengerChange}
                        options={messengerlist} 
                        placeholder="Select Messanger"
                        />
                    </div>
                    <div className="col-12 col-md-4 mt-4">
                        <button className={`btn btn-primary${isSubmitting ? 'disabled' : ''}`} onClick={Submitpickup} disabled={isSubmitting}> {isSubmitting ? 'Looding...' : 'Fetch'}</button>
                    </div>
                </div>
              </div>
            </div>
            <section className="data_table">
                <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                    <table className="table table-hover">
                        <thead>
                        <tr>
                                <th className="border-gray-200">Schedule Unique ID #</th>
                                <th className="border-gray-200">Date Time</th>
                                <th className="border-gray-200">Product Type</th>
                                <th className="border-gray-200">Address</th>
                                <th className="border-gray-200">Type</th>
                                <th className="border-gray-200">weight</th>
                                <th className="border-gray-200">Action</th>
                            </tr>
                        </thead>
                        {SubLoading==true? <tbody><tr><td colSpan={9}><ListLoader/></td></tr></tbody> : 
                            <tbody>
                                {list != undefined && list.length > 0 && list != null ? 
                                    <>
                                    {list.map((ship,index)=>{
                                        return(
                                            <tr key={index}>
                                            <td>
                                                <div>
                                                    <Link target="_blank" to={`/ShipmentDetails/${ship.sp_id}`} className="fw-bold">{ship.sp_id}</Link>
                                                    <CopyToClipboard text={ship.sp_id} onCopy={()=>{toast.success(ship.sp_id+' Copied To Clipboard')}}>
                                                        <i className="bx bx-copy"></i>
                                                    </CopyToClipboard>
                                                </div>
                                            </td>
                                            <td><span className="fw-normal text-capitalize"><small>{ship.pickup_date} {ship.pickup_time}</small></span></td>
                                            <td>
                                                <span className="fw-normal text-capitalize">{ship.product_type}</span>
                                            </td>
                                            <td>
                                                <span className="fw-normal text-capitalize">{ship.destination_address}</span>
                                            </td>
                                            <td>
                                                <span className="fw-normal text-capitalize">{ship.type}</span>
                                            </td>
                                            <td>
                                                <span className="fw-normal text-capitalize">{ship.totalweight}</span>
                                            </td>
                                            <td>
                                                <Link to={`/CourierBarcode/${ship.sp_id}/${ship.cust_id}`} target="_blank" className="btn btn-gray-100 btn-sm" data-bs-toggle="tooltip" title="List of Shipments"><i className="bx bx-barcode"></i></Link>
                                                <Link to={`/CustomerScheduledPickupList/${ship.sp_id}/${ship.cust_id}`} target="_blank" className="btn btn-gray-100 btn-sm" data-bs-toggle="tooltip" title="List of Shipments"><i className="bx bx-box"></i></Link>
                                            </td>
                                        </tr>
                                    );
                                })}   
                                    </>
                                :
                                    <tr>
                                        <td colSpan="9" className="text-center">Record Not Found</td>
                                    </tr>
                                }                    
                            </tbody>
                        }
                    </table>
                </div>
            </section>

            
            </>
            }
            <Footer/>
        </main>
    </>
);
}
export default AllScheduledPickupList;